export const VERIFICATION_PROCESS_CONFIG = {
  initIdentification: 'onboarding_extended',
  rootIdentification: 'identification',
  subProcesses: {
    identification: {
      provider: 'sub_professional_identification',
      patient: 'sub_patient_identification',
      representative: 'sub_representative_identification',
      person: 'sub_user_demographics_identification'
    },
    verification: {
      // provider: 'sub_professional_verification',
      professional: 'sub_professional_verification',
      patient: 'sub_patient_verification',
      representative: 'sub_representative_verification',
      person: 'sub_user_demographics_verification',
    },
  },
};

export const ONBOARDING_PROCESS_DEFINITONS = {
  PATIENT: 'patient',
  EHEALTH_RECORD: 'ehealth_record',
};
